import axiosInstance from "../../apiAxios/axiosInstance";


export const getEnquriesList = async (payload) => {
  const response = await axiosInstance.post("/vendor/vendor-moduls-inquiry-list", payload);
  return response.data;
};
export const EnquriesDetail = async (payload) => {
  const response = await axiosInstance.post("/vendor/vendor-moduls-inquiry-view", payload);
  return response.data;
};
export const AddBrand = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-store", payload);
  return response.data;
};
export const VendorEnquiry = async (payload) => {
  const response = await axiosInstance.post("/vendor/vendor-module-inquiry", payload);
  return response.data;
};

export const ViewEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/contact-us-show", payload);
  return response.data;
};

export const UpdateBrand = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-update", payload);
  return response.data;
};

export const DeleteEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/contact-us-delete", payload);
  return response.data;
};

export const BrandChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/brand-status-update",
    payload
  );
  return response.data;
};